import { SearchTrigger } from "../searchTrigger/SearchTrigger";
import { StepId, SearchData, SearchFormErrors, Step } from "../../types";
import { getInputValue } from "../../utils/getInputValue";
import { useFormikContext } from "formik";
import styles from "./CompactSearch.module.scss";
import { useIntl } from "react-intl";

type CompactSearchProps = {
	steps: Step[];
	onClick: (id: StepId) => void;
};

export const CompactSearch = ({ steps, onClick }: CompactSearchProps) => {
	const { formatDate, formatMessage } = useIntl();
	const { values, errors: formikErrors, touched, setFieldError } = useFormikContext<SearchData>();
	const errors = formikErrors as SearchFormErrors;

	const travelDates = values.travelDates;
	const departureDate = travelDates && travelDates.departureDate;
	const endDate = travelDates && travelDates.endDate;

	const departureCityStep = steps.find((step: Step) => step.id === "departureCity") as
		| Step
		| undefined;
	const destinationResortStep = steps.find((step: Step) => step.id === "destinationResort") as
		| Step
		| undefined;
	const travelDatesStep = steps.find((step: Step) => step.id === "travelDates") as
		| Step
		| undefined;

	const hasDepartureAndDestination = Boolean(departureCityStep) && Boolean(destinationResortStep);

	const handleTriggerClick = (id: StepId) => {
		setFieldError(id, undefined);
		onClick(id);
	};

	const formatShortDate = (date: string | Date) =>
		formatDate(date, {
			weekday: "short",
			day: "2-digit",
			month: "short",
		});

	return (
		<>
			{Boolean(departureCityStep) && (
				<SearchTrigger
					label={departureCityStep ? departureCityStep.title : ""}
					className={
						hasDepartureAndDestination
							? styles["compact-search__city-departure--stacked"]
							: undefined
					}
					onClick={() => handleTriggerClick("departureCity")}
					value={getInputValue(values.departureCity)}
					error={Boolean(touched.departureCity && errors.departureCity)}
				/>
			)}

			{Boolean(destinationResortStep) && (
				<SearchTrigger
					label={destinationResortStep ? destinationResortStep.title : ""}
					className={
						hasDepartureAndDestination
							? styles["compact-search__city-destination--stacked"]
							: undefined
					}
					onClick={() => handleTriggerClick("destinationResort")}
					value={getInputValue(values.destinationResort, false)}
					error={Boolean(touched.destinationResort && errors.destinationResort)}
				/>
			)}

			{Boolean(travelDatesStep) && (
				<div className={styles["compact-search__travel-dates"]}>
					<SearchTrigger
						label={formatMessage({
							id: "sdp.search.departure.date.side.panel.title",
						})}
						className={styles["compact-search__travel-date--left"]}
						onClick={() => handleTriggerClick("travelDates")}
						value={departureDate ? formatShortDate(departureDate) : undefined}
						error={Boolean(
							touched.travelDates &&
								errors.travelDates &&
								errors.travelDates.departureDate
						)}
					/>

					<SearchTrigger
						label={formatMessage({
							id: "sdp.search.destination.date.side.panel.title",
						})}
						className={styles["compact-search__travel-date--right"]}
						onClick={() => handleTriggerClick("travelDates")}
						value={endDate ? formatShortDate(endDate) : undefined}
						error={Boolean(
							touched.travelDates && errors.travelDates && errors.travelDates.endDate
						)}
					/>
				</div>
			)}
		</>
	);
};
